import { useState } from "react";
import { deleteNoteURL } from "../../utils/ConstantsURL";
import { toastAlert } from "../../utils/AlertContext";

export const useDeleteNote = (token, note, onDeleteSuccess, close) => {
  const [loading, setLoading] = useState(false);

  const deleteNote = async () => {
    setLoading(true);

    try {
      const response = await fetch(deleteNoteURL(note.id_sintesis), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        toastAlert("Error al eliminar la nota", "error");
        setLoading(false);
        return;
      }

      toastAlert("Nota eliminada correctamente", "success");
      setLoading(false);
      onDeleteSuccess();
      close();
    } catch (error) {
      toastAlert("Error al eliminar la nota: " + error, "error");
      setLoading(false);
    }
  };
  return { loading, deleteNote };
};
